"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = require("@insided/shared/utils/globals");

var _algolia = require("@insided/shared/services/algolia");

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

var _algoliaService = require("../../services/algoliaService");

var _utils = require("@insided/destination/modules/Search/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AutoSuggestTags = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AutoSuggestTags, _Component);

  var _super = _createSuper(AutoSuggestTags);

  function AutoSuggestTags(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AutoSuggestTags);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      suggestedTags: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cb", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var client;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _algolia.createAlgoliaClient)(data.client_id, data.token);

              case 2:
                client = _context.sent;

                _this.setState({
                  index: client.initIndex((0, _utils.getCommunityId)())
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _globals.subscribe)('title_changed', function (_ref2) {
      var title = _ref2.title;
      return _this.autoSuggest(title);
    });
    return _this;
  }

  (0, _createClass2.default)(AutoSuggestTags, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _algoliaService.getSearchToken)(this.cb);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "autoSuggest",
    value: function autoSuggest(topicName) {
      var _this2 = this;

      var index = this.state.index;

      if (topicName === '' || index === undefined) {
        this.setState({
          suggestedTags: []
        });
        return;
      }

      index.search({
        query: topicName,
        attributesToRetrieve: ['title', 'tags']
      }).then(function (_ref3) {
        var hits = _ref3.hits;
        var tagSet = {};
        var results = hits.reduce(function (result, hit) {
          var _hit$tags;

          (_hit$tags = hit.tags) === null || _hit$tags === void 0 ? void 0 : _hit$tags.forEach(function (tag) {
            if (Object.prototype.hasOwnProperty.call(result, tag)) {
              result[tag]++;
            } else {
              result[tag] = 1;
            }
          });
          return result;
        }, tagSet);

        _this2.setState({
          suggestedTags: Object.keys(results).sort(function (a, b) {
            return results[b] - results[a];
          }).slice(0, 3)
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isTagSelected = _this$props.isTagSelected,
          selectPublicTag = _this$props.selectPublicTag;
      var suggestedTags = this.state.suggestedTags;
      return suggestedTags.length > 0 && (0, _preact.h)("div", {
        className: "public-tag-suggestions-container"
      }, suggestedTags.map(function (tag) {
        return isTagSelected(tag) ? null : (0, _preact.h)("button", {
          className: "suggested-public-tag",
          onClick: function onClick() {
            return selectPublicTag({
              name: tag
            }, false);
          },
          key: tag
        }, tag, "\xA0", (0, _preact.h)(_Add.default, {
          width: 16,
          height: 16
        }));
      }));
    }
  }]);
  return AutoSuggestTags;
}(_preact.Component);

exports.default = AutoSuggestTags;